<template>
  <div class="alert-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Alert'
}
</script>
<style lang="stylus" scoped>
.alert-container
  color: #3c763d
  background-color: #dff0d8
  border-color: #d6e9c6
  padding: 15px
  margin-bottom: 20px
  border: 1px solid transparent
  border-radius: 4px
  a.link
    color:inherit
    text-decoration: none
</style>
